import React, { useEffect, useRef, useState } from "react";
import { CircularProgress, IconButton, Tooltip, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Rating from "@material-ui/lab/Rating";
import { v4 as uuid } from "uuid";
import api from "../../services/api";
import { errorMessage } from "./helpers";
import useStyles from "./styles";

export default function Classification({ contactId, name, classification, version = 0, onSaved, disabled = false }) {
  const classes = useStyles();
  const [current, setCurrent] = useState({ classification: classification || null, version });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false);
  const alive = useRef(true);
  const [inputName] = useState(() => `crm-classification-${contactId}-${uuid()}`);
  useEffect(() => () => { alive.current = false; }, []);
  useEffect(() => { setCurrent({ classification: classification || null, version }); }, [classification, version]);
  const save = async value => {
    if (pending.current || disabled || value === current.classification) return;
    pending.current = true;
    setSaving(true);
    setError("");
    try {
      const { data } = await api.patch(`/crm/contacts/${contactId}/profile`, { classification: value, version: current.version });
      if (!alive.current) return;
      setCurrent({ classification: data.classification, version: data.version });
      if (onSaved) onSaved(data);
    } catch (err) {
      if (!alive.current) return;
      if (err.response && err.response.status === 409) {
        setError("Outra pessoa alterou este perfil. Confira a classificação atual antes de tentar novamente.");
        try {
          const { data } = await api.get(`/crm/contacts/${contactId}`);
          if (!alive.current) return;
          setCurrent({ classification: data.profile.classification, version: data.profile.version });
          if (onSaved) onSaved(data.profile);
        } catch (reloadError) { if (alive.current) setError("Não foi possível atualizar a classificação. Atualize a página e tente novamente."); }
      } else setError(errorMessage(err));
    } finally { pending.current = false; if (alive.current) setSaving(false); }
  };
  return <div className={classes.ratingSummary} role="group" aria-label={`Classificação de ${name}`} aria-busy={saving}>
    <div className={classes.ratingLine}>
      <Rating name={inputName} className={classes.ratingStars} value={current.classification} disabled={disabled || saving} onChange={(_, value) => save(value)} getLabelText={value => `${value} ${value === 1 ? "estrela" : "estrelas"}`} emptyLabelText="Sem classificação" />
      {saving ? <CircularProgress size={16} aria-label="Salvando classificação" /> : current.classification ? <Tooltip title="Remover classificação"><IconButton size="small" disabled={disabled} aria-label="Remover classificação" onClick={() => save(null)}><Close style={{ fontSize: 15 }} /></IconButton></Tooltip> : null}
    </div>
    <Typography variant="caption" className={current.classification ? classes.ratingValue : classes.ratingEmpty} aria-live="polite">{current.classification ? `${current.classification}/5` : "Sem classificação"}</Typography>
    {error && <Typography variant="caption" color="error" role="alert">{error}</Typography>}
  </div>;
}
